import { router } from "@inertiajs/react"
import AppLayout from "@/components/AppLayout"
import PageTitle from "@/components/PageTitle"
import { Button } from "@/components/ui/Button"
import { test_notifications_path } from "@/lib/routes"
import SlackIntegrationCard, { type SlackState } from "./components/SlackIntegrationCard"
import GoogleIntegrationCard, { type GoogleState } from "./components/GoogleIntegrationCard"

interface Props {
  slack: SlackState
  google: GoogleState
}

// The page is a registry of integration providers. Slack and Google exist today; more
// cards drop in here without reshaping the page.
export default function IntegrationsIndex({ slack, google }: Props) {
  return (
    <AppLayout
      header={
        <PageTitle
          title="Integrations"
          subtitle="Connect Atlas to the tools your team already uses"
        />
      }
    >
      <div className="max-w-3xl space-y-4">
        <SlackIntegrationCard slack={slack} />
        <GoogleIntegrationCard google={google} />

        <div className="flex items-center justify-between rounded-lg border border-border bg-card p-4">
          <div>
            <p className="text-sm font-medium text-foreground">Test notification</p>
            <p className="text-xs text-muted-foreground">
              Send yourself a sample notification — it appears in the bell and, if Slack
              is connected, as a DM.
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => router.post(test_notifications_path(), {}, { preserveScroll: true })}
          >
            Send test notification
          </Button>
        </div>
      </div>
    </AppLayout>
  )
}
